import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAnalyticsConfiguration } from '@obvious.tech/constellation'

export const AnalyticsConfiguration = defineEntity('AnalyticsConfiguration', {
  endpoint: 'analytics/api/AnalyticsConfiguration',
  schema: SNoop<IAnalyticsConfiguration>(),
})
